import createCardListingView from '../Views/createCardListingView';
import FlexJobCard from './FlexJobCard';

export default createCardListingView(FlexJobCard, {
  displayName: 'JobListingView',
  useContainer: true,
});
